import { createBrowserRouter, RouterProvider } from "react-router-dom";
import PublicRoutes from "./publicRoutes";

const RoutesContainer = () => {
  const router = createBrowserRouter([
    {
      path: "*",
      element: <PublicRoutes />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default RoutesContainer;
